import { makeStyles } from "@fluentui/react-components";

export const useConfigurationsStyles = makeStyles({
  tab: {
    "&>span": {
      pointerEvents: "none",
    },
  },
});
